module.exports = __webpack_public_path__ + "media/images/athletes/3548-e57ae85e617b2e0f2f06f2ec07750ab4.png";